import superMeta from '../_DES_CAT/metaDesCatNode.mjs'

export default {
    ...superMeta,
    name: '需求',
    type: 'CHG_TASK',
}
